export default {
    terminal: {
        TERMINAL_ADDED: 'Terminal successfully added',
        TERMINAL_EDITED: 'Terminal successfully edited',
    },
    company: {
        COMPANY_ADDED: 'Company successfully added',
        COMPANY_EDITED: 'Company successfully edited',
    },
    place: {
        PLACE_ADDED: 'Place successfully added',
        PLACE_EDITED: 'Place successfully edited',
    },
    product: {
        PRODUCT_ADDED: 'Product successfully added',
        PRODUCT_EDITED: 'Product successfully edited',
    },
    nestedProduct: {
        PRODUCT_ADDED: 'Nested product successfully added',
        PRODUCT_EDITED: 'Nested product successfully edited',
    },
    website: {
        WEBSITE_ADDED: 'Website successfully added',
        WEBSITE_EDITED: 'Website successfully edited',
    },
    company_owner: {
        COMPANY_OWNER_ADDED: 'Company owner successfully added',
        COMPANY_OWNER_EDITED: 'Company owner successfully edited',
    },
    order: {
        ORDER_EDITED: 'Order successfully edited',
    },
    productCategory: {
        PRODUCT_CATEGORY_ADDED: 'Product category successfully added',
        PRODUCT_CATEGORY_EDITED: 'Product category successfully edited',
    },
    nestedProductCategory: {
        NESTED_PRODUCT_CATEGORY_ADDED: 'Nested product category successfully added',
        NESTED_PRODUCT_CATEGORY_EDITED: 'Nested product category successfully edited',
    },
    promotion: {
        PROMOTION_ADDED: 'Promotion successfully added',
        PROMOTION_EDITED: 'Promotion successfully edited',
    },
};
